import React from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { Box } from "@mui/material";

interface IPagination {
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (value: number) => void;
}

const PaginationComponent = ({ currentPage, totalPages, onPageChange }: IPagination) => {
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    onPageChange(value);
  };
  return (
    <Box display="flex" alignItems="center" justifyContent="center" sx={{ mt: 4 }}>
      <Stack spacing={2}>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handleChange}
          variant="outlined"
          color="primary"
        />
      </Stack>
    </Box>
  );
};

export default PaginationComponent;
